/* ==========================================================================
   VITAL VIAL - Article reading progress
   ========================================================================== */
(function () {
  'use strict';

  var bar = document.querySelector('[data-vv-progress]');
  if (!bar) return;

  var article = document.querySelector('.vv-article-section article, article');
  if (!article) return;

  var ticking = false;

  function update() {
    var rect = article.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var scrolled = -rect.top;
    var pct = total > 0 ? Math.min(Math.max(scrolled / total, 0), 1) : 0;
    bar.style.width = (pct * 100).toFixed(2) + '%';
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });

  window.addEventListener('resize', update);
  update();
})();
